var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 78,
    viewBox: "0 0 62 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_28597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.461 0H40.2073V58.4204C33.6784 59.6554 28.872 60.1413 23.6717 60.1413C8.1038 60.125 0 53.17 0 39.8125C0 26.9426 8.59591 18.59 21.9164 18.59C23.9834 18.59 25.5581 18.7526 27.461 19.24V0ZM27.9077 29.768C26.4148 29.2804 25.1846 29.118 23.6097 29.118C17.1629 29.118 13.4391 33.0504 13.4391 39.9419C13.4391 46.6517 16.999 50.3566 23.5279 50.3566C24.9384 50.3566 26.0868 50.2771 27.9077 50.0334V29.768Z",
    fill: "#2BA977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0495 20.1584V49.4087C61.0495 59.4819 60.2949 64.3261 58.0803 68.5025C56.0133 72.5177 53.2902 75.0495 47.6635 77.846L35.8359 72.2724C41.4626 69.6575 44.1857 67.347 45.9247 63.8208C47.7453 60.215 48.3195 56.0385 48.3195 45.0536V20.1587H61.0495V20.1584ZM47.035 0H59.7813V12.9513H47.035V0Z",
    fill: "#2BA977"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_28597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.2456,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg19);
export default __webpack_public_path__ + "static/media/img19.7c36f186e0b788f46d54911a80563f6f.svg";
export { ForwardRef as ReactComponent };